import { styled, Stack, Avatar, Typography, Button, Alert } from '@mui/material';
import { useMemo } from 'react';
import { AnalyticsEvents } from '@common/utils/analytics/events';

const StyledAvatar = styled(Avatar)({
  width: 250,
  height: 200,
});

interface AddAccessStatesProps {
  status: 'success' | 'error' | 'warning';
  title: string;
  subtitle?: string;
  hasApprovers?: boolean;
  onUseAccess?: () => void;
  onCheckDetails?: () => void;
  dataProps?: string;
}

export default function AddAccessStates({
  status,
  title,
  subtitle,
  hasApprovers,
  onUseAccess,
  onCheckDetails,
  dataProps,
}: AddAccessStatesProps) {
  const illustration = useMemo(() => {
    switch (status) {
      case 'success':
        return '/static/illustrations/success.svg';
      case 'error':
        return '/static/illustrations/error.svg';
      case 'warning':
        return '/static/illustrations/warning.svg';
    }
  }, [status]);

  return (
    <Stack direction="column" alignItems="center" justifyContent="center">
      <StyledAvatar src={illustration} />
      <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
        <Typography variant="subtitle1">{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.muted">
            {subtitle}
          </Typography>
        )}
        {hasApprovers && (
          <Alert severity="info" variant="outlined">
            Access to some resources require approval. <br />
            Go to &quot;My requests&quot; for more information
          </Alert>
        )}
        <Stack direction="row" spacing={2}>
          {onCheckDetails && (
            <Button
              variant={onUseAccess ? 'text' : 'contained'}
              color="primary"
              onClick={onCheckDetails}
              data-trigger={AnalyticsEvents.CheckRequestDetailsClicked}
              data-props={dataProps}
            >
              {onUseAccess ? 'Check failure details' : 'Check requests  details'}
            </Button>
          )}
          {onUseAccess && (
            <Button
              variant="contained"
              color="primary"
              onClick={onUseAccess}
              data-trigger={AnalyticsEvents.UseAccessClicked}
              data-props={dataProps}
            >
              Use Access
            </Button>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
